import styled from "styled-components";

export const Title = styled("h3")`
  margin: 0px;
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;
  margin: 0;
`;

export const Card = styled('div') <{ background?: string }>`
  position: relative;
  overflow: hidden;
  padding: 32px 0px;
  ${({ background }) => background ? `background: ${background}` : ""};
  background-size: 200%;
  
  @media(min-width: 768px){
    padding: 40px 0px;
  }
`

export const Flex = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  
  @media(min-width: 768px){
    justify-content: flex-end;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0px;

  @media (max-width: 768px) {
    top: -15px;
    right: 15px;
  }
`;